import { render, staticRenderFns } from "./CharitableGiftsYN.vue?vue&type=template&id=fa92d440"
import script from "./CharitableGiftsYN.vue?vue&type=script&lang=js"
export * from "./CharitableGiftsYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports